import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  border: PropTypes.bool,
};

const defaultProps = {
  required: false,
  onChange: null,
  value: '',
  className: '',
  border: false,
};

const TextArea = props => {
  const { name, id, placeholder, onChange, required, value, className, border, onBlur } = props;

  return (
    <textarea
      {...props}
      className={clsx('appearance-none block w-full min-h-16 overflow-auto', className)}
      border={border}
      name={name}
      id={id}
      placeholder={placeholder}
      onChange={onChange ? e => onChange(e) : null}
      required={required}
      value={value || ''}
      onBlur={onBlur}
    />
  );
};

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;

export default TextArea;
